export default __webpack_public_path__ + "static/media/bg-login.426ac1fc.png";